module.exports = __webpack_public_path__ + "img/GavialData DAMP.42bdad87.png";